import { useCallback } from 'react';
import { useMutation } from 'react-query';
import { useAxios } from '../context/AxiosContext';
import { downloadFileFromResponse } from '../utils/fileDownload';

export function useWelcomeEmail() {
  const { authAxios } = useAxios();
  const fetchInstruction = useCallback(async () => {
    const response = await authAxios.get('/welcome-email', {
      responseType: 'blob'
    });
    downloadFileFromResponse(response, 'TeladocHealthClientPortalGuide.pdf');
  }, [authAxios]);
  const mutatioInst = useMutation(fetchInstruction);
  return {
    fetchInstruction: mutatioInst.mutateAsync
  };
}
